// @flow

type Callbacks = {
  connected?: () => void,
  disconnected?: (data: { willAttemptReconnect: boolean }) => void,
  rejected?: () => void,
  received?: (data: { [string]: any }) => void
};

export default class BaseChannel {
  subscription: ?{ unsubscribe: () => void, perform: (string, {}) => void }
  params: {}
  callbacks: Callbacks

  static channelName: string

  static subscribe(params: {} = {}, callbacks: Callbacks) {
    return new this(params, callbacks).subscribe();
  }

  get channelName(): string {
    return this.constructor.channelName;
  }

  constructor(params: {} = {}, callbacks: Callbacks) {
    this.params = params;
    this.callbacks = callbacks;
  }

  subscribe() {
    this.subscription = window._cable.consumer.subscriptions.create({
      ...this.params,
      channel: this.channelName
    }, this);

    return this;
  }

  perform(action: string, data: {} = {}) {
    if (this.subscription) {
      this.subscription.perform(action, data);
    }
  }

  unsubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }

    return this;
  }

  connected = () => {
    if (this.callbacks.connected) {
      this.callbacks.connected();
    }
  }

  disconnected = (data: { willAttemptReconnect: boolean }) => {
    if (this.callbacks.disconnected) {
      this.callbacks.disconnected(data);
    }
  }

  rejected = () => {
    if (this.callbacks.rejected) {
      this.callbacks.rejected();
    }
  }

  received = (data: {}) => {
    if (this.callbacks.received) {
      this.callbacks.received(data);
    }
  }
}
